import css from './index.module.scss';
import { formatCMValue, getCMTone } from '@helpers/utils';

interface ICMValueProps {
  amount: number;
  percent: number;
  currency?: string;
}

// CM amount with its %, coloured by sign: green positive, red negative, blue zero
const CMValue = (props: ICMValueProps) => {
  const { amount, percent, currency } = props;

  if (!currency) return <>-</>;

  return <span className={css[getCMTone(amount)]}>{formatCMValue(amount, percent, currency)}</span>;
};

export default CMValue;
